/* eslint-disable react/prop-types */
import LICENSE_STATUS from "@/constants/licenseStatus";
import React from "react";

import { isAuth } from "@/network/helper";
import { useRouter } from "next/router";
import styles from "./layoutStyle.module.scss";
import { INACTIVE_NOTICE_EXCLUDED_PATHS } from "./constant";
import { Alert } from "@mui/material";


const requiredActiveLicense = (path) =>
  !INACTIVE_NOTICE_EXCLUDED_PATHS.some((item) => path.startsWith(item));


export default function InactiveLicenseAlert({ licenseStatus }) {
  const router = useRouter();
  return (
    <>
      {requiredActiveLicense(router.pathname) &&
        isAuth() &&
        licenseStatus == LICENSE_STATUS.VIEW_ONLY && (
          <div className={`${styles.center_el}`}>
            <Alert
              severity="info"
              sx={{
                fontSize: "1.6rem",
                borderRadius: "10px",
              }}
            >
              You can only view. Please contact your admin to activate your
              license.
            </Alert>
          </div>
        )}
    </>
  );
}
